import {post} from '../script/serviceApiPost';

export default{
  async getData(dataRow: any) {
    // let result=await post("system/UserLogin/login", {dataRow:dataRow});
    // let result=await post("test/getData", dataRow);
    const result = await post('test/getData', dataRow);
    return result;
  },
  async ajaxLogin(dataRow: any) {
    const result = await post('tbUser/ajaxLogin', dataRow);
    return result;
  },
  // 登出
  async logout(dataRow: any) {
    const result = await post('tbUser/logout', dataRow);
    return result;
  },
  async add(dataRow: any) {
    const result = await post('tbUser/add', dataRow);
    return result;
  },
  async editPassword(dataRow: any) {
    const result = await post('tbUser/editPassword', dataRow);
    return result;
  },
  
};
